import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import About from '../pages/About';
import Services from '../pages/Services';
import Team from '../pages/Team';
import ServiceDetails from '../pages/ServiceDetails';
import Portfolio from '../pages/Portfolio';
import ProjectDetails from '../ProjectDetails/ProjectDetails';
import ContacUs from '../pages/ContacUs';
import NotFound from '../pages/NotFound';

const Routers = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="/about" element={<About />} />
      <Route path="/services/:id" element={<ServiceDetails />} />
      <Route path="/team" element={<Team />} />
      <Route path="/services" element={<Services />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/project/:id" element={<ProjectDetails />} />
      <Route path="/contact" element={<ContacUs />} />
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Routers;
